import { useGLTF } from '@react-three/drei';
import { useContext } from 'react';

import dc_blue from '@/assets/models/blue_donation_cup.glb';
import dc_green from '@/assets/models/green_donation_cup.glb';
import dc_red from '@/assets/models/red_donation_cup.glb';
import dc_yellow from '@/assets/models/yellow_donation_cup.glb';
import PhysicsWall from '@/components/game/3d/physics/PhysicsWall';
import { GameContext } from '@/state/contexts';

const BoxContainer = ({ showMesh }) => {
	const wall_thicc = 0.25;
	const wall_w = 1.75;
	const wall_h = 20;
	return (
		<>
			<PhysicsWall
				size={[2, 0.75, 2]}
				pos={[0, -2, 0]}
				showMesh={showMesh}
			/>
			<PhysicsWall
				size={[wall_thicc, wall_h, wall_w]}
				pos={[2, 2, 0]}
				showMesh={showMesh}
			/>
			<PhysicsWall
				size={[wall_thicc, wall_h, wall_w]}
				pos={[-2, 2, 0]}
				showMesh={showMesh}
			/>
			<PhysicsWall
				size={[wall_w, wall_h, wall_thicc]}
				pos={[0, 2, 2]}
				showMesh={showMesh}
			/>
			<PhysicsWall
				size={[wall_w, wall_h, wall_thicc]}
				pos={[0, 2, -2]}
				showMesh={showMesh}
			/>
		</>
	);
};

export const DonationCup = ({ playerId, matColor, matPathId }) => {
	let path = [dc_yellow, dc_blue, dc_red, dc_green];

	const { playerStateArray, myState }: any = useContext(GameContext);

	const notMyCup = myState.playerId !== playerId;

	const { nodes, materials } = useGLTF(path[matPathId]);

	const scale = 0.36;

	if (
		!playerStateArray ||
		playerStateArray == null ||
		playerStateArray?.length < 1
	) {
		<group dispose={null}>
			<mesh
				castShadow
				receiveShadow
				geometry={(nodes.lyoc_donation_cup as any).geometry}
				material={materials['Material.001']}
				rotation={[0, Math.PI / 2, 0]}
				position={[12, 7, 16]}
				scale={scale}
			/>
		</group>;
	}

	return (
		<>
			{notMyCup && (
				<mesh castShadow receiveShadow position={[12, 8.25, 16]}>
					<boxGeometry args={[3.5, 0.1, 3.5]} />
					<meshStandardMaterial
						color={'grey'}
						roughness={0.55}
						metalness={0.55}
					/>
				</mesh>
			)}
			<group position={[12, 6.75, 16]}>
				<mesh
					castShadow
					receiveShadow
					geometry={(nodes.lyoc_donation_cup as any).geometry}
					material={materials['Material.001']}
					rotation={[0, Math.PI / 2, 0]}
					scale={scale}
				/>
				<BoxContainer showMesh={false} />
			</group>
		</>
	);
};

useGLTF.preload(dc_blue);
